import React from 'react'

function Blogs() {
  return (
    <div>
      <h1>No Blogs Available NOW</h1>
    </div>
  )
}

export default Blogs
